"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const reviews_1 = require("@dialogexe/cw-website-store/reviews");
const movie_1 = require("@dialogexe/cw-website-store/movie");
class MovieReviews extends React.Component {
    constructor() {
        super(...arguments);
        this.itemsPerPage = 4;
        this.componentDidMount = () => {
            this.props.getReviewsAction.requestReviews(this.props.movie.reference);
            this.setState({
                itemsDisplayed: this.itemsPerPage
            });
        };
        this.renderLoading = () => {
            const { isLoadingReviews } = this.props;
            if (isLoadingReviews) {
                return (React.createElement("div", { className: "level is-center" },
                    React.createElement("div", { className: "spinner" },
                        React.createElement("div", { className: "dot-1" }),
                        React.createElement("div", { className: "dot-2" }),
                        React.createElement("div", { className: "dot-3" }))));
            }
        };
        this.openMore = () => {
            this.setState({
                itemsDisplayed: this.state.itemsDisplayed + this.itemsPerPage
            });
        };
    }
    render() {
        const { reviews, movieInfo } = this.props;
        if (reviews.length === 0) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: "MovieReviews" },
            React.createElement("h1", { className: "title" }, "Grunner til \u00E5 se den"),
            movieInfo &&
                React.createElement("div", { className: "rating" },
                    React.createElement("div", { className: "rating rating-rate" }, movieInfo.rating),
                    React.createElement("div", { className: "rating rating-label" }, "av 6 "),
                    React.createElement("div", { className: "rating rating-count" }, `( ${movieInfo.ratingCount} vurderinger)`)),
            React.createElement("div", { className: "movie-reviews" },
                React.createElement("div", { className: "row is-spaced" },
                    this.renderLoading(),
                    reviews.slice(0, this.state.itemsDisplayed).map((review, index) => (React.createElement("div", { className: "column is-xs-12 is-md-12 is-lg-6", key: index },
                        React.createElement("div", { className: "movie-review" },
                            React.createElement("div", { className: "movie-review-header" },
                                " ",
                                review.userName,
                                " "),
                            React.createElement("div", { className: "movie-review-body" },
                                " ",
                                review.comment,
                                " "))))),
                    reviews.length > this.state.itemsDisplayed &&
                        React.createElement("div", { className: "level is-center" },
                            React.createElement("button", { className: "button is-contained", onClick: this.openMore }, "Se flere"))))));
    }
}
exports.MovieReviews = MovieReviews;
exports.default = react_redux_1.connect((state) => ({
    reviews: state.reviews.items,
    movieInfo: state.movie.movieInfo,
    isLoadingReviews: state.reviews.loading
}), (dispatch) => ({
    getReviewsAction: redux_1.bindActionCreators(reviews_1.actionCreators, dispatch),
    getMovieInfoAction: redux_1.bindActionCreators(movie_1.actionCreators, dispatch),
}))(MovieReviews);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-movie-reviews/MovieReviews.tsx